import React from "react";
import { Box, useCheckbox } from "@chakra-ui/react";
import { colors } from "../../Theme";
import { CheckIcon } from "@chakra-ui/icons";

const CheckboxCard = (props: any) => {
  const { getInputProps, getCheckboxProps } = useCheckbox(props);

  const input = getInputProps(props);
  const checkbox = getCheckboxProps(props);
  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        cursor="pointer"
        borderWidth="1px"
        borderRadius="none"
        boxShadow="none"
        data-checked={props.checked}
        borderColor={colors.brown}
        checked={props.checked}
        _checked={{
          color: colors.brown,
          px: 0,
          py: 0
        }}
        _focus={{
          boxShadow: "none",
        }}
        w="calc(2rem + 5px)"
        h="calc(2rem + 5px)"
      >
          { props.checked && <CheckIcon boxSize={'calc(2rem + 1px)'}/> }
        {props.children}
      </Box>
    </Box>
  );
};

export default CheckboxCard;
